

export const toRem = (s?: number | string | null): string => {
    if (typeof s === 'number') return toRem(s.toString());
    if (!s) return 'initial';
    if (s.match(/auto|initial/)) return s;
    if (s.match(/(\d+)(px|rem|em|pt|pc|in|cm|mm|ex|ch|vw|vh|vmin|vmax|%)/)) return s;
    return s.split(' ').filter(x => !!x).map(x => x + 'rem').join(' ');
};

export const remInPx = (r?: number | string | null): number => typeof r !== 'number'
    ? remInPx(parseFloat(r as any))
    : r * (window.devicePixelRatio >= 2 ? 14 : 16);

export const remToPx = (r?: number | string | null): string => `${remInPx(r)}px`;
